export default {
  title: 'reset hasła',
  type: 'object',
  properties: {
    mail: {
      type: 'string',
      title: 'Email',
      format: 'email',
      fieldRequired: true,
      validationMessages: {
        format: 'Nieprawidłowy format, e-mail musi być wprowadzony w formacie nazwa@domena.'
      }
    }
  }
};
